import { Bandeira } from './bandeira.enum';

export class ClientePreLogin {
  telefone: string;
  cpf: string;
  bandeira: Bandeira;
  origem: string;

  constructor() {
    this.cpf = '';
    this.telefone = '';
    this.origem = '';
  }
}
